import React from "react";
import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImagePreview from "./ImagePreview";
import color from "../../Constants/colors";
import { useTranslation } from "react-i18next";

interface ImagePreviewModalProps {
  open: boolean;
  onClose: () => void;
  documentId?: number | null;
  url?: string;
  documentName?: string;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  open,
  onClose,
  documentId,
  url,
  documentName,
}) => {
  const { t } = useTranslation("documentUpload");
  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        padding: "20px",
      }}
    >
      <Box
        sx={{
          backgroundColor: color.white,
          borderRadius: "8px",
          border: `1px solid ${color.gray200}`,
          width: "100%",
          maxWidth: "900px",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px 24px",
            borderBottom: `1px solid ${color.gray200}`,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              margin: 0,
              fontSize: "1rem",
              fontWeight: 600,
              color: color.primary_dark,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {documentName ?? t("documentUpload.imagePreview.title")}
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              padding: "8px",
              borderRadius: "4px",
              "&:hover": { backgroundColor: color.gray100 },
            }}
          >
            <CloseIcon sx={{ color: color.gray500 }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: "hidden" }}>
          {url ? (
            <ImagePreview key={url} url={url} />
          ) : (
            documentId != null && (
              <ImagePreview key={documentId} documentId={documentId} />
            )
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ImagePreviewModal;
